import {
  canRetryCreationPersist,
  isCreationResultPersistFailure,
} from '@glyphic/shared-core'

export const TERMINAL_CREATION_STATUS = new Set(['SUCCEEDED', 'FAILED'])

/** 与 waitForCreationTask 默认一致 */
export const DEFAULT_CREATION_RECOVERY_MAX_WAIT_MS = 15 * 60 * 1000

export const DEFAULT_CREATION_STALE_MS = 15 * 60 * 1000

export function isCreationTaskTerminal(task: { status?: string }): boolean {
  if (!task.status) return false
  return TERMINAL_CREATION_STATUS.has(task.status)
}

/** @deprecated 使用 isCreationResultPersistFailure */
export function isStoragePersistFailure(message: string | null | undefined): boolean {
  return isCreationResultPersistFailure({ errorMessage: message })
}

export { canRetryCreationPersist, isCreationResultPersistFailure }

/**
 * 时间线轮次是否可尝试「重试落库」。
 * 优先使用任务 reconcilable；轮次无该字段时回退 errorMessage 启发式。
 */
export function canRetryPersistRound(round: {
  status?: string
  taskId?: string
  items?: unknown[]
  errorMessage?: string | null
  errorCode?: string | null
  reconcilable?: boolean
}): boolean {
  if (!round.taskId?.trim() || String(round.taskId).startsWith('demo-')) return false
  if (round.status !== 'FAILED' && round.status !== 'UNAVAILABLE') return false
  if (Array.isArray(round.items) && round.items.length > 0) return false
  return canRetryCreationPersist({
    status: round.status,
    errorCode: round.errorCode,
    errorMessage: round.errorMessage,
    reconcilable: round.reconcilable,
  })
}

export function creationTaskAgeMs(
  task: { updatedAt?: string | null; createdAt?: string | null },
  staleMs = DEFAULT_CREATION_STALE_MS,
): number {
  const raw = task.updatedAt ?? task.createdAt
  if (!raw) return staleMs + 1
  const t = Date.parse(raw)
  return Number.isFinite(t) ? Date.now() - t : staleMs + 1
}

export type RecoverCreationTaskOptions = {
  /** 非终态时是否阻塞等待完成（页面重入恢复） */
  waitForCompletion?: boolean
  maxWaitMs?: number
  staleMs?: number
  /** 失败且为落库类错误时是否自动补偿入队（默认 true） */
  reconcileStorageFailure?: boolean
}

/**
 * 时间线轮次是否需要与后端对账（重进页面 / 下拉刷新 / 中断恢复统一入口）。
 * 本地已成功且有成品图则跳过；其余有 taskId 的轮次均应对账。
 */
export function roundNeedsTaskRecovery(round: {
  taskId?: string
  status?: string
  items?: unknown[]
}): boolean {
  if (!round.taskId?.trim() || String(round.taskId).startsWith('demo-')) return false
  const hasItems = Array.isArray(round.items) && round.items.length > 0
  if (round.status === 'SUCCEEDED' && hasItems) return false
  if (round.status === 'CANCELLED') return false
  return true
}
